import { useEffect } from 'react'

export const useLocalStorageChangeEffect = (handleStorageChange: () => void): void => {
    useEffect(() => {
        // Add the event listener
        window.addEventListener('localStorage', handleStorageChange)

        // Return a clean-up function
        return () => {
            // Remove the event listener
            window.removeEventListener('localStorage', handleStorageChange)
        }
    }, [handleStorageChange]) // Dependency array includes handleStorageChange
}
